import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="daily-competition" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <div className="w-full max-w-3xl rounded-3xl overflow-hidden mb-10 md:mb-14">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20scene%20showing%20a%20crowd%20of%20people%20engrossed%20in%20their%20smartphones%20with%20glowing%20screens%2C%20dramatic%20overhead%20spotlight%20creating%20theatrical%20atmosphere%2C%20warm%20amber%20and%20red%20accent%20colored%20light%20beams%2C%20editorial%20photography%20with%20film%20grain%20texture%2C%20mysterious%20and%20engaging%20mood%2C%20social%20media%20and%20gossip%20culture%20theme&width=1400&height=700&seq=home-cta-2026&orientation=landscape"
              alt="每日大赛 - 吃瓜群众"
              className="w-full h-auto object-cover object-top"
              loading="lazy"
            />
          </div>

          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mb-4 leading-tight">
            今天你
            <em className="not-italic text-foreground-400 font-normal">吃瓜</em>
            了吗？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
            每日大赛实时更新，最新黑料大瓜不停歇。加入千万吃瓜群众，不错过任何一个精彩瞬间。
          </p>

          <Link
            to="/category/daily-competition"
            className="px-8 py-3.5 rounded-full bg-foreground-950 text-white font-semibold text-sm md:text-base hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            进入每日大赛
            <div className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}